<template>
  <div>
    <div v-if="messageType === 'error'" class="InputAlert_error">
        {{ message }}
    </div>
    <div v-else-if="messageType === 'warning'" class="InputAlert_warning">
        {{ message }}
    </div>
    <div v-else-if="messageType === 'success'" class="InputAlert">
        {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    messageType: String
  }
}
</script>

<style lang="scss" scoped>
.InputAlert_warning{
  font-size: 12px;
  color: red;
  position: absolute; 
}
</style>